export { default } from './Img.vue'



// WEBPACK FOOTER //
// ./src/lib/wind-ui/package/img/index.js